import { CarTireInputWrapperModel } from "./carTireInputWrapperModel";

export const CarTireInputWrapper = ({ children }: CarTireInputWrapperModel) => {
  return <div className="tire-input-wrapper mb-3">{children}</div>;
};
